import React, { useEffect, useRef, useState } from 'react';
import ReactMarkdown from 'react-markdown';
import gfm from 'remark-gfm';
import { TypingAnimationProps } from '../assets/interfaces/interfaces';

const TypingAnimation: React.FC<TypingAnimationProps> = ({ text, speed }) => {
    return (
        <div className='markdown-body'>
            <ReactMarkdown 
              children={text} 
              remarkPlugins={[gfm]} 
            />
        </div>
    );
};

export default TypingAnimation;
